import { Wifi, WashingMachine, ShoppingBasket, Bike, Baby, Accessibility, PawPrint, CreditCard, UtensilsCrossed, Rabbit } from "lucide-react";
import { Chapter, Reveal } from "./Chapter";
import { SERVICES, IMAGES } from "../lib/data";

const ICONS = { Wifi, WashingMachine, ShoppingBasket, Bike, Baby, Accessibility, PawPrint, CreditCard };

export default function Services() {
  return (
    <section id="services" className="relative py-28 lg:py-36 px-6 sm:px-10 lg:px-16 grain" data-testid="section-services">
      <div className="max-w-7xl mx-auto">
        <Chapter num="5" label="Services & vie au camping" />
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight text-ink max-w-3xl">
            Des vacances <span className="italic font-medium text-pine">sans contrainte</span>,
            pensées pour votre bien-être.
          </h2>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-12 gap-6">
          <Reveal className="lg:col-span-7" delay={0.1}>
            <div className="group relative h-full min-h-[320px] overflow-hidden rounded-[2rem] shadow-xl shadow-ink/10" data-testid="service-restaurant">
              <img
                src={IMAGES.restaurant}
                alt="Paëlla géante sur la terrasse du restaurant La Table de Bannac"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-lakedeep/85 via-lakedeep/20 to-transparent" />
              <div className="absolute bottom-0 p-8">
                <span className="inline-flex items-center gap-2 rounded-full bg-gold text-ink text-xs font-bold tracking-[0.15em] uppercase px-3 py-1.5">
                  <UtensilsCrossed size={13} /> Ouvert en été
                </span>
                <h3 className="mt-4 font-display font-bold text-3xl text-sand">La Table de Bannac</h3>
                <p className="mt-2 text-sand/75 max-w-md text-sm leading-relaxed">
                  Le restaurant du camping, sa terrasse et sa cuisine gourmande pour des soirées
                  sans cuisiner, face à la nature aveyronnaise.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={0.2}>
            <div className="group relative h-full min-h-[320px] overflow-hidden rounded-[2rem] shadow-xl shadow-ink/10 rotate-1 transition-transform duration-500 hover:rotate-0" data-testid="service-ferme">
              <img
                src={IMAGES.ferme}
                alt="L'âne de la mini-ferme du camping à Martiel"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-pinedark/85 via-pinedark/15 to-transparent" />
              <div className="absolute bottom-0 p-8">
                <span className="inline-flex items-center gap-2 rounded-full bg-sand text-pine text-xs font-bold tracking-[0.15em] uppercase px-3 py-1.5">
                  <Rabbit size={13} /> Les enfants adorent
                </span>
                <h3 className="mt-4 font-display font-bold text-3xl text-sand">La mini-ferme</h3>
                <p className="mt-2 text-sand/75 text-sm leading-relaxed">
                  Le nourrissage des animaux avec Dino, notre mascotte : le rendez-vous préféré des petits campeurs.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.label} delay={0.05 * i}>
                <div
                  className="group h-full rounded-2xl border border-ink/10 bg-cream/70 p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-pine/10 hover:border-pine/30"
                  data-testid={`service-card-${i}`}
                >
                  <span className="grid place-items-center w-10 h-10 rounded-full bg-lake text-sand transition-transform duration-300 group-hover:-rotate-12">
                    <Icon size={17} />
                  </span>
                  <div className="mt-4 font-display font-bold text-ink">{s.label}</div>
                  <div className="text-sm text-ink/55 mt-1">{s.text}</div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
